export const INITIAL_REQUEST_STATE = {
  isRequesting: false,
  requestError: false
}

export const ACTIONS = {
  CALLING_API: "CALLING_API",
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
}

export const requestReducer =  (state, action) => {
  switch (action.type){
    case ACTIONS.CALLING_API: {
      return  {...state, isRequesting: true}
    }
    case ACTIONS.SUCCESS: {
      return  {...state, isRequesting: false}
    }
    case ACTIONS.ERROR: {
      return  {isRequesting: false, requestError: action.payLoad}
    }
  }
}